import { createStore, applyMiddleware, compose } from 'redux'
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from './reducers/rootReducer';


const history = createHistory();
const middleware = routerMiddleware(history);

const defaultState = {
  posts: [{id: 'yy', url: 'lalala.png', caption: 'waka', likes: 12}, {id: 'xx', url: 'wakaaaaaa.png', caption: 'wooka', likes: 84}],
  comments: {
    'yy': [{text: 'lalalal comment', user: 'lala'}],
    'xx': [{text: 'the xx photo is bomb', user: 'morgan'}]
  }
};

const enhancers = compose(
    window.devToolsExtension ? window.devToolsExtension() : f => f
)

const store = createStore(
  rootReducer,
  defaultState,
  enhancers,
  applyMiddleware(middleware)
);

export { history };
export default store;



// WEBPACK FOOTER //
// ./src/store.js